/**
 * Created by Victor Rojo on 6/9/17.
 */
import { Component, OnDestroy }    from '@angular/core';
import { Router }                   from '@angular/router';
import { NotificationsService }   from 'angular2-notifications';

import { I18NService }              from "../shared/i18n/i18n.service";
import { IPlaceService }            from '../iPlace/iPlace.service'
import { CloudUserIPlaceService }   from "../iPlace/cloudUseriPlace.service";
import { AuthService }              from "../shared/auth/auth.service";

import {interval as observableInterval,  Subject,  Unsubscribable as AnonymousSubscription } from 'rxjs';

import {distinctUntilChanged, debounceTime} from 'rxjs/operators';

import {iPlace} from "../model/iPlace";
import {CloudUseriPlace} from "../model/cloudUseriPlace";
import {NotificationService} from "../notification/notification.service";

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.css']
})
export class DashboardComponent implements OnDestroy{

  statusFilterValues= [
    {real:null, display:"All"},
    {real:1, display:"Online"},
    {real:0, display:"Offline"}];

  activetStatusFilterValue: number = null;
  data: CloudUseriPlace[] = [];
  rows: any;
  isBusy = '';
  isLicenseDownloadBusy = '';
  isLoading = true;
  private searchText= '';
  private searchTerms = new Subject<string>();
  private interval: AnonymousSubscription;
  private subscription: any;
  unreadNotificationCounters:any = {};
  tableMessages: any;
  isAdmin = false;

  constructor(
    private iPlaceService: IPlaceService,
    private cloudUserIPlaceService: CloudUserIPlaceService,
    private i18nService: I18NService,
    private notificationService: NotificationService,
    private notificationsService: NotificationsService,
    private authService: AuthService,
    private router: Router
  ){
    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.filterRows();
      });
    this.cloudUserIPlaceService.get()
      .then( list => {
        this.data = list;
        this.filterRows();
        this.isLoading = false;
      });

    this.interval = observableInterval(10000)
      .subscribe(() => {
        this.cloudUserIPlaceService.get()
          .then( list => {
            this.data = list;
            this.filterRows();
          });
    });
    let lastUnreadCount = this.notificationService.getLastUnreadCount();
    if (lastUnreadCount) {
      this.updateUnreadCounters(lastUnreadCount);
    }

    this.subscription = this.notificationService.unreadChange$.subscribe( (records:any[]) => this.updateUnreadCounters(records));

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    let roles = this.authService.getUserRoles();
    this.isAdmin = roles.reduce( (carry, value) => carry || value == "ROLE_END_USER_ADMIN", false);
  }

  public ngOnDestroy(): void {
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
  }

  private updateUnreadCounters(records:any[]) {
    records.forEach(record => {
      this.unreadNotificationCounters[record.idiPlace] = record.unread > 99 ? "+99" : record.unread;
    });
  }

  getStatusClass(value: number){
    return value == 1 ? "label-success" : "label-default";
  }

  onClickStatusFilter(value: number): void{
    if ( value != this.activetStatusFilterValue ) {
      this.activetStatusFilterValue = value;
    }
    this.filterRows();
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  private statusFilter(row: any){
    return ( this.activetStatusFilterValue == null || row.iPlace.tunnelStatus == this.activetStatusFilterValue);
  }

  private searchFilter(row: any){
    return ( !this.searchText || row.iPlace.iPlaceName.toUpperCase().indexOf(this.searchText) != -1
              || row.iPlace.ipAddress.toUpperCase().indexOf(this.searchText) != -1
              || row.iPlace.port.toString().toUpperCase().indexOf(this.searchText) != -1
              || row.localUser.toUpperCase().indexOf(this.searchText) != -1
    );
  }

  filterRows(): void {
    this.rows = this.data.filter( row => {
      return this.statusFilter(row) && this.searchFilter(row);
    })
  }

  launchIPlace(uuid: string):void {
    this.isBusy = uuid;
    this.iPlaceService
      .localLogin(uuid)
      .then(response => { this.isBusy = null })
      .catch(error => {
        var errorTitle = this.i18nService.get("conectionError"), errorContent = this.i18nService.get("errorLoginInstance");
        if ( error.endsWith("NOT ACTIVE TUNNEL SESSION")) {
          errorContent = this.i18nService.get("instanceOffline")
        }
        this.notificationsService.error(errorTitle, errorContent);
        this.isBusy = null;
      });
  }

  downloadIPlaceLicense(uuid: string):void {
    this.isLicenseDownloadBusy = uuid;
    this.iPlaceService.getLicenseFile(uuid)
      .then(response => { this.isLicenseDownloadBusy = null })
      .catch(error => {
        if ( error.code ) {
          var errorContent = this.i18nService.get( error.code == 1061 ? "licenseGenerationFailed" : "licenseAccessDenied");
          var errorTitle = this.i18nService.get("error");
          this.notificationsService.error(errorTitle,errorContent);
        }
        this.isLicenseDownloadBusy = null;
      });
  }

  seeNotifications(record:any) {
    this.router.navigate(['notifications/', {filter: record.iPlace.iPlaceName}]);
  }
}
